export default __webpack_public_path__ + "static/media/FrankHomies-60.659a5633.png";